export interface translation {
  name: string
  language: string
  description: string
  keywords: string[]
}

export interface listPaginatedOfTopicsList {
  _id: string
  name: string
  description: string
  isActive: boolean
  prompt: string
  translations: translation[]
  beta: boolean
}

export interface listPaginatedOfTopicsInfo {
  page: number
  size: number
  pages: number
  offset: number
  totalItems: number
  currentItems: number
  list: listPaginatedOfTopicsList[]
}

export interface listPaginatedOfTopicsResponse {
  message: string
  status: number
  info: listPaginatedOfTopicsInfo
}

export interface listPaginatedOfTopicsRequest {
  page?: number
  pageSize?: number
  status?: string
}

interface useCasesTranslations {
  description: string
  language: string
  name: string
}

export interface listOfUseCasesInfo {
  _id: string
  name: string
  description: string
  requiredComplianceForm: boolean
  translations: useCasesTranslations[]
  default: boolean
  isForCompanySearch: boolean
}
export interface listOfUseCasesResponse {
  info: listOfUseCasesInfo[]
}

export interface startNewPersonSearchRequest {
  name?: string
  middleName?: string
  lastName?: string

  email?: string
  phone?: string

  twitterUrl?: string
  facebookUrl?: string
  instagramUrl?: string
  tikTokUrl?: string
  linkedInUrl?: string
  pinterestUrl?: string
  redditUrl?: string
  picture?: string

  pdfLanguage: string

  topics?: string[]
}

export interface statsInfo {
  completedReports: number
  pendingReports: number
}
export interface getStatsResponse {
  info: statsInfo
}

export interface findSubjectRequest {
  page: number
  linkedinUrl: string
  firstName?: string
  lastName?: string
  company?: string
  school?: string
  reportType: string
}

export interface findSubjectLocation {
  country: string
  city: string
  full: string
}

export interface findSubjectItem {
  firstName: string
  lastName: string
  headline: string
  profilePicture: string
  location: findSubjectLocation
  profileURL: string
  alias: string
  company: string
  collage: string
}
export interface findSubjectData {
  page: number
  count: number
  pages: number
  items: findSubjectItem[]
}
export interface findSubjectResponse {
  status: number
  message: string
  info: findSubjectData
}

export enum ESocialMedia {
  LINKEDIN = 'LinkedIn',
  FACEBOOK = 'Facebook',
  INSTAGRAM = 'Instagram',
  PINTEREST = 'Pinterest',
  TIKTOK = 'TikTok',
  TWITTER = 'Twitter',
  REDDIT = 'Reddit',
  WEBSEARCH = 'WebSearch',
}

export enum EReportStatus {
  Searching = 'Searching',
  Scraping = 'Scraping',
  IaAnalysis = 'IaAnalysis',
  Completed = 'Completed',
}

export interface getStatusData {
  progress: number
  status: EReportStatus
  currenScraping: ESocialMedia
}

export interface getStatusResponse {
  status: number
  message: string
  info: getStatusData
}

export interface getStatusRequest {
  subjectId: string
}

export interface profilePrivacyDto {
  socialMedia: ESocialMedia
  url: string
}

export interface checkPrivacyRequest {
  profiles: profilePrivacyDto[]
}

export interface privacyResult {
  socialMedia: ESocialMedia
  url: string
  isPrivate: boolean
}

export interface checkPrivacyResponse {
  message: string
  info: {
    status: number
    message: string
    data: {
      results: privacyResult[]
    }
    isError: boolean
    timestamp: string
    path: string
  }
  status: number
}
